/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "components/elements/spinner/spinner.css";
import { ReactComponent as SpinnerSvg } from "components/elements/spinner/spinner.svg";

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner">
        <div className="loader">
          <SpinnerSvg />
        </div>
      </div>
    </div>
  );
};

export default Spinner;
